// HINT: If parent component has 'display: flex', please use 'min-width: 0' for parent in order to make component EllipsisToolTip works
// Source https://css-tricks.com/flexbox-truncated-text/

import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import useTooltip from '../../hooks/useTooltip';

import styles from '../../styles/views/components/EllipsisToolTip.module.scss';

const EllipsisToolTip = ({ tooltipText, wrapperExtraStyles, children }) => {
  useTooltip();

  const [showTooltip, setShowTooltip] = useState(false);

  const mouseEnterHandler = useCallback((e) => {
    if ((e.target?.offsetWidth !== e.target?.scrollWidth) && !showTooltip) {
      setShowTooltip(true);
    } else if ((e.target?.offsetWidth === e.target?.scrollWidth) && showTooltip) {
      setShowTooltip(false);
    }
  }, [showTooltip, setShowTooltip]);

  return (
    <div className={styles.container} style={wrapperExtraStyles} data-tip={showTooltip ? tooltipText : ''} onMouseEnter={mouseEnterHandler}>
      {children}
    </div>
  );
};

EllipsisToolTip.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  tooltipText: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  wrapperExtraStyles: PropTypes.object,
};

EllipsisToolTip.defaultProps = {
  wrapperExtraStyles: {},
};


export default EllipsisToolTip;
